<template>
  <DialogTemplate
    data-tst="solfigr_rakedialog"
    style="--dialog-content-overflow: none"
  >
    <IcmStructuresTables
      style="mh-0"
      @click:item="handleClick"
    />

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        data-tst="btn_apply"
        variant="text"
        @click="close"
        >{{ $t('btn.close') }}</v-btn
      >
      <portal-target name="dialog_actions" />
    </template>
  </DialogTemplate>
</template>

<script>
import IcmStructuresTables from '@/components/DataTables/v2/tables/IcmStructuresTable/IcmStructuresTables'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import { applyTournamentStructure } from '@/store/solfigr/solfigr_helpers'

export default {
  name: 'SolfigrIcmStructuresDialog',
  components: {
    IcmStructuresTables,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  methods: {
    handleClick({ item }) {
      applyTournamentStructure({ item, namespace: this.namespace, store: this.$store })
      this.close()
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'solfigr-icm-structures-dialog')
    },
  },
  computed: {
    namespace() {
      return this.dialog.namespace || null
    },
  },
}
</script>
